import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex mb-1"
}
const _hoisted_2 = { class: "container" }
const _hoisted_3 = {
  key: 0,
  style: {"max-width":"50ch"}
}

import { request } from "@/domains/api/api";
import { useLoading } from "@/domains/app/loading";
import { usePaginatedResourcesState } from "@/domains/app/resource";
import { useUser } from "@/domains/auth/user";
import { computed, ref } from "@vue/reactivity";
import { watch } from "vue";
import BaseList from "../../../search/components/List.vue";
import {
    ADMINISATRATION_LEVEL_DELEGATE,
    ADMINISATRATION_LEVEL_USER,
    Department,
} from "../../departments/departments";
import { ROLE_DELEGATE } from "../../users/users";


export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const selectedScope = ref<"user" | "department" | "country">("user");
const { scope: userScope, user } = useUser();
const getResourcesState = () =>
    usePaginatedResourcesState<any>(
        "locations",
        true,
        computed(() => ({ scope: selectedScope.value }))
    );

const makeDriver = () => ({
    loadingKey: "locations.loading.list",
    getLabel: (location: any) => location.label,
});

const depId = computed(() =>
    user.value !== null ? user.value.department_id : null
);
const departmentAdministration = ref<
    typeof ADMINISATRATION_LEVEL_DELEGATE | typeof ADMINISATRATION_LEVEL_USER
>();
watch(
    depId,
    (id) => {
        if (!id) return;
        departmentAdministration.value = undefined;
        const setLoading = useLoading("gic.list.department").setLoading;
        setLoading(true);
        request<Department>("departments/" + id, "get")
            .then((rs) => {
                if (rs)
                    departmentAdministration.value = rs.administration_level;
            })
            .finally(() => setLoading(false));
    },
    { immediate: true }
);
const headerText = computed(
    () =>
        selectedScope.value === "country"
            ? ""
            : selectedScope.value === "user"
            ? departmentAdministration.value === ADMINISATRATION_LEVEL_DELEGATE
                ? "Ce sont vos lieux, vous pouvez les utiliser pour vos interventions sur les départements dont le délégué ne gère pas les lieux"
                : "Ce sont vos lieux, vous pouvez les utiliser pour vos interventions sur votre département et sur les départements dont le délégué ne gère pas les lieux"
            : departmentAdministration.value === ADMINISATRATION_LEVEL_DELEGATE
            ? "Les lieux de cette liste sont les lieux que les conducteurs peuvent utiliser sur votre département"
            : "" // No list to show in this case
);

return (_ctx: any,_cache: any) => {
  const _directive_loading_key = _resolveDirective("loading-key")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_unref(userScope) !== 'user')
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("button", {
            class: _normalizeClass(["btn", {
                'btn-light': selectedScope.value !== 'user',
                'btn-secondary': selectedScope.value === 'user',
            }]),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedScope.value = 'user'))
          }, " Mes lieux ", 2),
          (_unref(userScope) === 'department' || _unref(userScope) === 'country')
            ? (_openBlock(), _createElementBlock("button", {
                key: 0,
                class: _normalizeClass(["btn ms-1", {
                'btn-light': selectedScope.value !== 'department',
                'btn-secondary': selectedScope.value === 'department',
            }]),
                onClick: _cache[1] || (_cache[1] = ($event: any) => (selectedScope.value = 'department'))
              }, " Lieux de mon département ", 2))
            : _createCommentVNode("", true),
          (_unref(userScope) === 'country')
            ? (_openBlock(), _createElementBlock("button", {
                key: 1,
                class: _normalizeClass(["btn ms-1", {
                'btn-light': selectedScope.value !== 'country',
                'btn-secondary': selectedScope.value === 'country',
            }]),
                onClick: _cache[2] || (_cache[2] = ($event: any) => (selectedScope.value = 'country'))
              }, " Lieux du pays ", 2))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_2, [
      (
                _unref(user)?.roles.includes(_unref(ROLE_DELEGATE)) &&
                departmentAdministration.value === _unref(ADMINISATRATION_LEVEL_USER) &&
                selectedScope.value === 'department'
            )
        ? (_openBlock(), _createElementBlock("p", _hoisted_3, " Vous ne pouvez pas consulter les Lieux de votre département. Pour gérer vous même les GIC/Demandeurs/Lieux de votre département, veuillez contacter contact@geschasse.fr "))
        : (_openBlock(), _createBlock(BaseList, {
            key: 1,
            title: "Liste des lieux",
            "allow-delete-many": true,
            "get-resources-state": getResourcesState,
            "api-resource-base": "locations",
            "make-item-driver": makeDriver,
            "new-item-route": { name: `locations.create` },
            "search-placeholder": "Nom",
            "header-text": _unref(headerText)
          }, null, 8, ["new-item-route", "header-text"]))
    ])), [
      [_directive_loading_key, 'gic.list.department']
    ])
  ], 64))
}
}

})